module.exports = __webpack_public_path__ + "img/Help_Icon_Hover.5bee53d0.svg";